<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { Button, Card, Input, Select } from '@drama/ui'

import { api, getToken } from '../api.js'

const { t } = useI18n()
const router = useRouter()
const settings = ref(null)
const message = ref('')
const supervisor_agent_id = ref('')
const supervisor_options = ref([])

async function saveSupervisor() {
  try {
    await api('PUT', '/api/voko/me/supervisor', { agent_id: supervisor_agent_id.value === '' ? null : supervisor_agent_id.value })
    message.value = t('agents.saved')
  } catch (err) {
    message.value = err instanceof Error ? err.message : String(err)
  }
}
const hours = Array.from({ length: 24 }, (_, hour) => ({ value: hour, label: `${String(hour).padStart(2, '0')}:00` }))

async function save() {
  message.value = ''
  try {
    // 输入框清空表示不登记。
    await api('PUT', '/api/voko/me/settings', { ...settings.value, github_login: settings.value.github_login === '' ? null : settings.value.github_login })
    message.value = t('agents.saved')
  } catch (err) {
    message.value = err instanceof Error ? err.message : String(err)
  }
}

function useBrowserZone() {
  settings.value.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
}

onMounted(async () => {
  if (getToken() === null) {
    await router.push({ path: '/login', query: { next: '/settings' } })
    return
  }
  const [selection, mine] = await Promise.all([api('GET', '/api/voko/me/supervisor'), api('GET', '/api/voko/agents')])
  supervisor_agent_id.value = selection.agent_id === null ? '' : selection.agent_id
  supervisor_options.value = [{ value: '', label: t('okr.noSupervisor') }, ...mine.agents.filter((agent) => agent.status === 'active').map((agent) => ({ value: agent.id, label: agent.full_name }))]
  const loaded = (await api('GET', '/api/voko/me/settings')).settings
  settings.value = { ...loaded, github_login: loaded.github_login === null ? '' : loaded.github_login }
})
</script>

<template>
  <h1>{{ t('settings.title') }}</h1>
  <p><router-link to="/agents">{{ t('board.back') }}</router-link></p>
  <Card v-if="settings">
    <label class="voko-field">{{ t('okr.supervisor') }}<Select :aria-label="t('okr.supervisor')" v-model="supervisor_agent_id" :options="supervisor_options" /></label>
    <p>{{ t('okr.supervisorHint') }}</p>
    <Button @click="saveSupervisor">{{ t('settings.save') }}</Button>
  </Card>
  <Card v-if="settings">
    <label class="voko-field">{{ t('settings.timezone') }}<Input v-model="settings.timezone" /></label>
    <p><Button variant="ghost" @click="useBrowserZone">{{ t('settings.useBrowserZone') }}</Button></p>
    <p>{{ t('settings.quietHint') }}</p>
    <div class="voko-field">
      <span>{{ t('settings.quietStart') }}</span>
      <Select v-model="settings.quiet_start_hour" :options="hours" :aria-label="t('settings.quietStart')" />
    </div>
    <div class="voko-field">
      <span>{{ t('settings.quietEnd') }}</span>
      <Select v-model="settings.quiet_end_hour" :options="hours" :aria-label="t('settings.quietEnd')" />
    </div>
    <label class="voko-check"><input v-model="settings.email_help" type="checkbox"> {{ t('settings.emailHelp') }}</label>
    <label class="voko-check"><input v-model="settings.email_digest" type="checkbox"> {{ t('settings.emailDigest') }}</label>
    <label class="voko-field">{{ t('settings.githubLogin') }}<Input v-model="settings.github_login" autocomplete="off" /></label>
    <p>{{ t('settings.githubHint') }}</p>
    <p v-if="message" role="status">{{ message }}</p>
    <Button @click="save">{{ t('settings.save') }}</Button>
  </Card>
</template>

<style scoped>
.voko-check {
  display: block;
  margin-bottom: var(--drama-space-md);
}
</style>
